import { gql } from '@apollo/client';

export const updateHost = gql`
  mutation updateHost($hostInput: UpdateHostInput) {
    updateHost(input: $hostInput) {
      altId
    }
  }
`;
